import { useNavigate, useSearchParams, useMatch } from 'react-router-dom';
// import styled from 'styled-components';
import GiftSkeleton from './ClaimGiftSkeleton';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useLogin, useLoginWithEmail, usePrivy } from '@privy-io/react-auth';
import { useDispatch } from 'react-redux';
import { openModal } from '../../../redux/slices/modals';
import { useLogout } from '../../../hooks/useLogout';
import useCustomLogin from '../../../hooks/useCustomLogin';

const CheckEmail = () => {
  const { id } = useParams();
  const { user } = usePrivy();
  const { handleLogout } = useLogout();

  const [searchParams] = useSearchParams();
  const { login } = useCustomLogin();
  const rec = searchParams.get('rec');
  const [hasAttemptedLogin, setHasAttemptedLogin] = useState(false);

  const dispatch = useDispatch();

  let email;
  try {
    if (rec) {
      email = decodeURIComponent(escape(atob(rec)));
    }
  } catch (error) {
    console.error('Error decoding email:', error);
    email = null;
  }

  const { sendCode, loginWithCode } = useLoginWithEmail();
  const [code, setCode] = useState('');
  const isSurveyClaim = useMatch('/gifts/:id/survey-claim');

  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      if (email && user?.email?.address !== email) {
        dispatch(
          openModal({
            name: 'confirmation',
            props: {
              onContinue: () => handleLogout(),
              onCancel: () => {
                navigate('/');
              },
              title: 'Receive Gift',
              text: `It looks like the email associated with this gift is different from your current account. Would you like to log in with ${email}?`,
            },
          }),
        );
      } else {
        navigate(
          `/app/gifts/${id}/${!!isSurveyClaim ? 'survey-claim' : 'claim'}`,
        );
      }
    }
  }, [user, email, id, navigate, handleLogout]);

  // Reset hasAttemptedLogin when user becomes null
  useEffect(() => {
    if (!user) {
      setHasAttemptedLogin(false);
    }
  }, [user]);

  useEffect(() => {
    if (!email || user || !login || hasAttemptedLogin) return;

    const debounceTimeout = setTimeout(() => {
      setHasAttemptedLogin(true);
      login({
        prefill: {
          type: 'email',
          value: email,
        },
      });
    }, 500);

    return () => clearTimeout(debounceTimeout);
  }, [user, email, login, hasAttemptedLogin]);

  if (email && !user) {
    return <GiftSkeleton />;
  }

  return <GiftSkeleton />;
};

export default CheckEmail;
